"use strict";

stateProviders.push({
    name: "schoolside.reports.spreadsheets",
    url: "/spreadsheets",
    templateUrl: "fast/submodules/schoolside/reports/submodules/spreadsheets/partials/spreadsheets.html?v=" + versionNo,
    controller: "SpreadsheetsController",
    resolve: {
        spreadsheets: function(SpreadsheetModelService, authServiceFactory)
        {
            return SpreadsheetModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        ssq: function(AskSchoolSpecificQuestionsModelService, authServiceFactory)
        {
            return AskSchoolSpecificQuestionsModelService.get(authServiceFactory.getAuth().schoolID);
        },
        reports: function(ReportsModelService)
        {
            return (ReportsModelService.resolveData(""));
        },
        budgets: function(AccountModelService, authServiceFactory)
        {
            return AccountModelService.get(authServiceFactory.getAuth().schoolID);
        }
    }
});
